var FcDataCardV2Module = /** @class */ (function () {
    function FcDataCardV2Module() {
    }
    return FcDataCardV2Module;
}());
export { FcDataCardV2Module };
